<script setup lang="ts">
import { useMmText } from './text'
withDefaults(defineProps<{ width?: string; height?: string }>(), { width: '100%', height: '14px' })
const { t } = useMmText()
</script>

<template><div class="skel" :style="{ width, height }" role="status"><span class="mm-sr-only">{{ t('common.loading') }}</span></div></template>
